import type {
  CommonSort,
  NestedFilter
} from '@@partner:types:graphql'
import { RsuiteSortType } from '@@partner:types:app'

import React, { useCallback, useMemo, useState } from 'react'
import { head } from 'rambda'
import { useParams } from 'react-router-dom'

import { FlexboxGrid, Pagination, Panel, SelectPicker } from 'rsuite'

import ShopSlotsTable from '@components/shop/slot/ShopSlotsTable'
import SlotsFilter from '@components/shop/slot/SlotsFilter'

import { useQueryAllSlots } from '@@partner:graphql/query/shop/allSlots.gql'
import { SORT_ORDER_DESC } from '@@partner:config/graphql'

import { useGridHelper } from '@@partner:helpers/crud/grid'


const DEFAULT_LIMIT_OPTIONS = [
  10,
  20,
  50,
  100
]


export default function ShopSlotsPage () {
  const { brandSlug, shopId, type } = useParams<any>()

  const defaultShopFilter: NestedFilter = useMemo(
    () => 
      ({
        fields: type === 'shop' ? [ 'shop_id' ] : [ 'zone_id' ],
        op: 'eq',
        value: [ shopId ]
      }),
    [ shopId, type ]
  )

  const [ filter, setFilter ] = useState<NestedFilter>(defaultShopFilter)

  const { page, limit, defaultLimitOptions, tableSort, handlePageSelect, handleLimitSelect, handleSortColumn } =
    useGridHelper({
      defaultSortFieldName: 'ts_start',
      defaultSortDirection: SORT_ORDER_DESC,
      defaultSortType: 'desc',
      defaultLimit: 20,
      defaultLimitOptions: DEFAULT_LIMIT_OPTIONS

    })

  const { slots, pageInfo, loading, error, refetch } = useQueryAllSlots({
    filter,
    pager: {
      page,
      limit
    }, 
    sort: {
      fieldName: tableSort.fieldName,
      direction: tableSort.direction
    }
  })

  const shopName = slots ? head(slots)?.shop?.address : null

  const handleSort = (dataKey: string, sortType?: RsuiteSortType) => {
    handleSortColumn(dataKey, sortType)
  }

  const handleFilterChanged = useCallback((updatedFilter: NestedFilter) => {
    setFilter({
      and: [
        defaultShopFilter,
        updatedFilter
      ]
    })
    handlePageSelect(1)
  }, [ handlePageSelect, defaultShopFilter ])

  return (
    <div className="ShopsPage">
      <h1 className="u-heading">Слоты { type === 'shop' ? 'магазина' : 'зоны' } { shopName && shopName }</h1>
      <Panel shaded>
        <SlotsFilter onFilterChanged={handleFilterChanged} />

        <ShopSlotsTable
          loading={loading}
          slots={slots}
          brandSlug={brandSlug}
          shopId={shopId}
          onSortClick={handleSort}
          sort={tableSort}
        />

        <FlexboxGrid justify="space-between" align="middle" style={{ marginTop: 10 }}>
          <Pagination
            last
            first
            next
            prev
            ellipsis
            total={pageInfo?.total ?? 0}
            activePage={page}
            pages={pageInfo?.lastPage}
            maxButtons={10}
            onSelect={handlePageSelect}
          />
          <SelectPicker
            value={limit}
            data={defaultLimitOptions.map(key => ({ value: key, label: key }))}
            cleanable={false}
            searchable={false}
            onChange={handleLimitSelect}
          />
        </FlexboxGrid>
      </Panel>
    </div>
  )
}
